namespace $.$$ {
	type $shm_hitalama_map_catalog_project_data = {
		id: string
		title: string
		map_ids: string[]
	}

	type $shm_hitalama_map_catalog_tree_model = {
		roots: readonly string[]
		children: ReadonlyMap< string, readonly string[] >
	}

	type $shm_hitalama_map_catalog_deleted_project = {
		project: $shm_hitalama_map_project
		index: number
		title: string
	}

	// class Button_open extends $mol_button_open {
	// 	sub() {
	// 		return [
	// 			this.Icon(),
	// 			this.title(),
	// 			this.Native(),
	// 		]
	// 	}
	// }

	export class $shm_hitalama_map_catalog extends $.$shm_hitalama_map_catalog {
		@ $mol_mem_key
		override project_expanded( node: string, next?: boolean ): boolean {
			return this.$.$mol_state_local.value<boolean>( `$shm_hitalama_map_catalog.project_expanded(${ node })`, next ) ?? true
		}

		@ $mol_mem
		override List_head() { const head = super.List_head(); head.head_content = ()=> [ head.Title(), this.Help() ]; return head }
		override menu_link_arg( id: string ) { return { ...super.menu_link_arg( id ), help: 'off' } }

		private map_summary_migration_pending = new Map< string, { profile_id: string, map_id: string, force: boolean } >()
		private map_summary_migration_attempted = new Set< string >()
		private map_summary_migration_busy = ''
		private map_summary_migration_profile = ''

		@ $mol_mem
		map_project_entities() {
			const profile = this.profile()
			if( !profile ) return [] as readonly $shm_hitalama_map_project[]
			return profile.Map_projects_list( null ).remote_list()
		}

		@ $mol_mem
		map_projects() {
			const assigned = new Set< string >
			const projects: $shm_hitalama_map_catalog_project_data[] = []
			for( const project of this.map_project_entities() ) {
				const map_ids = ( project.Maps()?.remote()?.remote_list() ?? [] )
					.map( map => map.link().str )
					.filter( id => {
						if( assigned.has( id ) ) return false
						assigned.add( id )
						return true
					} )
				projects.push({
					id: project.link().str,
					title: project.title().trim() || 'Проект',
					map_ids,
				})
			}
			return { projects }
		}

		@ $mol_mem_key
		map_project( id: string ) {
			return this.map_project_entities().find( project => project.link().str === id ) ?? null
		}

		// @ $mol_memo.field
		// get $() {
		// 	return super.$.$mol_ambient({
		// 		$mol_button_open: Button_open,
		// 	})
		// }

		@ $mol_mem_key
		Page( id: any ) {
			return this.Book(id) as any
		}

		maps_list_visible( next?: boolean ): boolean {
			return this.$.$mol_state_local.value(this+'.maps_list_visible', next) ?? true
		}

		@ $mol_action
		close_maps_list() {
			this.maps_list_visible( false )
		}

		@ $mol_mem
		pages(): readonly any[] {
			if( this.maps_list_visible() ) return super.pages()

			try {
				return this.spread_pages_deep()
			} catch (error) {
				return [ this.status_page( $mol_promise_like(error) ? 'Loading...' : String( error ) ) ]
			}
		}

		@ $mol_mem_key
		status_page( message: string ) {
			return this.$.$mol_view.make({
				sub: ()=> [ message ],
			})
		}

		profile() {
			return $shm_hitalama_profile.current()
		}

		auto() {
			this.map_access_publications_auto()
			return super.auto()
		}

		@ $mol_mem
		map_access_publications_auto() {
			return this.$.$mol_error_fence( ()=> {
				const outbox = this.profile()?.Map_access_outbox()?.remote()
				return outbox?.repair() ?? null
			}, ()=> null, ()=> null )
		}

		@ $mol_mem
		list() {
			return this.profile()?.Maps_list(null)!
		}

		@ $mol_mem
		owned_entities() {
			return this.list()?.remote_list() as $shm_hitalama_map[] ?? []
		}

		@ $mol_mem
		owned_map_ids() {
			return this.owned_entities().map( map => map.link().toString() )
		}

		map_visited_store_key() {
			return 'map_visited_ids'
		}

		static map_ids_from_store( data: unknown ): string[] {
			if( Array.isArray( data ) ) return data.filter( id => typeof id === 'string' )
			if( !data || typeof data !== 'object' ) return []
			return Object.keys( data ).filter( id => ( data as Record< string, unknown > )[ id ] )
		}

		@ $mol_mem
		map_visited_ids( next?: readonly string[] ): string[] {
			const profile = this.profile()
			if( !profile ) return []
			if( next !== undefined ) {
				profile.store( this.map_visited_store_key(), Object.fromEntries(
					next.map( id => [ id, true ] ),
				) )
				return [ ... next ]
			}

			return this.$.$mol_error_fence(
				()=> $shm_hitalama_map_catalog.map_ids_from_store(
					profile.store( this.map_visited_store_key() ),
				),
				()=> [],
				()=> [],
			)
		}

		@ $mol_mem
		available_maps() {
			return this.$.$mol_error_fence(
				()=> this.$.$shm_hitalama_map_access_discovery.current().entries(),
				error=> $mol_fail( error ),
				()=> new Map< string, $shm_hitalama_map_access_invitation_data >(),
			)
		}

		@ $mol_mem
		available_map_ids() {
			const owned = new Set( this.owned_map_ids() )
			return [ ... this.available_maps().keys() ].filter( id=> !owned.has( id ) )
		}

		@ $mol_mem
		visited_map_ids() {
			const owned = new Set( this.owned_map_ids() )
			const available = new Set( this.available_map_ids() )
			return this.map_visited_ids().filter( id => !owned.has( id ) && !available.has( id ) )
		}

		@ $mol_action
		map_visit( id: string ) {
			const profile = this.profile()
			if( !profile || !id || this.owned_map_ids().includes( id ) ) return false

			// Do not base a write on `map_visited_ids()`: its render-time fallback is
			// deliberately empty while profile data is loading. The direct read suspends
			// until the persisted value is available, so visiting another map cannot
			// replace the previously synced list with `[ id ]`.
			const ids = $shm_hitalama_map_catalog.map_ids_from_store(
				profile.store( this.map_visited_store_key() ),
			)
			if( ids.includes( id ) ) return false
			profile.store( this.map_visited_store_key(), Object.fromEntries(
				[ ... ids, id ].map( item => [ item, true ] ),
			) )
			return true
		}

		@ $mol_mem
		entities() {
			return [
				... this.owned_entities(),
				... [ ... this.available_map_ids(), ... this.visited_map_ids() ].map( id =>
					$giper_baza_glob.Pawn( new $giper_baza_link( id ), $shm_hitalama_map ),
				),
			]
		}

		@ $mol_mem_key
		map_props( id: string ) {
			const fallback = { title: id, changed_at: 0, created_at: 0, access_level: '' }
			return this.profile()?.map_summary( id ) ?? {
				... fallback, title: this.available_maps().get( id )?.title || id,
			}
		}

		static map_summary_missing_ids(
			ids: readonly string[],
			summaries: Readonly< Record< string, $shm_hitalama_map_summary_data > >,
			attempted: ReadonlySet< string > = new Set,
		) {
			return [ ... new Set( ids ) ].filter( id => id && !summaries[ id ] && !attempted.has( id ) )
		}

		map_summary_migration_delay() {
			return this.map_summary_migration_attempted.size ? 2_000 : 5_000
		}

		map_summary_migration_defer( task: ()=> void ) {
			return new this.$.$mol_after_timeout( this.map_summary_migration_delay(), task )
		}

		@ $mol_action
		map_summaries_migration_auto() {
			const profile = this.profile()
			if( !profile ) return null

			const profile_id = profile.link().str
			if( this.map_summary_migration_profile !== profile_id ) {
				this.map_summary_migration_profile = profile_id
				this.map_summary_migration_pending.clear()
			}
			profile.map_summaries_upgrade()
			const selected = this.$.$mol_state_arg.value( 'map' ) ?? ''
			const ids = [ selected, ... this.owned_map_ids(), ... this.visited_map_ids() ]
			const attempted = new Set( ids.filter( id => this.map_summary_migration_attempted.has( `${ profile_id }:${ id }` ) ) )
			const missing = $shm_hitalama_map_catalog.map_summary_missing_ids(
				ids,
				profile.map_summaries(),
				attempted,
			)
			for( const map_id of missing ) {
				const key = `${ profile_id }:${ map_id }`
				this.map_summary_migration_pending.set( key, { profile_id, map_id, force: false } )
			}
			const selected_key = `${ profile_id }:${ selected }`
			if( selected && !this.map_summary_migration_attempted.has( selected_key ) ) {
				this.map_summary_migration_pending.set( selected_key, {
					profile_id,
					map_id: selected,
					force: true,
				} )
			}
			this.map_summary_migration_schedule()
			return null
		}

		map_summary_migration_schedule() {
			if( this.map_summary_migration_busy ) return
			const next = this.map_summary_migration_pending.entries().next().value as
				| [ string, { profile_id: string, map_id: string, force: boolean } ]
				| undefined
			if( !next ) return

			const [ key, item ] = next
			this.map_summary_migration_pending.delete( key )
			this.map_summary_migration_attempted.add( key )
			this.map_summary_migration_busy = key
			this.map_summary_migration_defer( ()=> {
				$mol_wire_async( this ).map_summary_migrate( item.profile_id, item.map_id, item.force ).then(
					result => this.map_summary_migration_finish( key, result === null ),
					error => this.map_summary_migration_finish( key, false, error ),
				)
			} )
		}

		map_summary_migrate( profile_id: string, id: string, force = false ) {
			const profile = this.profile()
			if( !profile || profile.link().str !== profile_id ) return null
			if( !force && profile.map_summary( id ) ) return false
			const map = this.$.$giper_baza_glob.Pawn(
				new this.$.$giper_baza_link( id ),
				this.$.$shm_hitalama_map,
			)
			profile.map_summary( id, map.summary() )
			return true
		}

		@ $mol_action
		map_summary_migration_finish( key: string, retry: boolean, _error?: unknown ) {
			if( this.map_summary_migration_busy === key ) this.map_summary_migration_busy = ''
			if( retry ) this.map_summary_migration_attempted.delete( key )
			this.map_summary_migration_schedule()
		}

		spread_title( id: string ) {
			return this.map_props( id ).title
		}

		@ $mol_mem_key
		map_rename( id: string, next?: boolean ) {
			return next ?? false
		}

		@ $mol_mem_key
		map_title_draft( id: string, next?: string ) {
			return next ?? this.spread_title( id )
		}

		@ $mol_mem_key
		map_title_content( id: string ) {
			return this.map_rename( id )
				? [ this.Map_title_input( id ) ]
				: [ this.Map_title( id ) ]
		}

		@ $mol_action
		map_title_save( id: string, next: string ) {
			const map = this.owned_entities().find( entity => entity.link().str === id )
			if( !map ) return this.spread_title( id )
			const current = map.title().trim() || this.spread_title( id )
			const title = next.trim() || current
			if( title === current ) return current
			map.title( title )
			map.summary_publish()
			return title
		}

		@ $mol_action
		map_rename_start( id: string, event?: Event | null ) {
			if( !this.owned_map_ids().includes( id ) ) return event ?? null
			event?.preventDefault()
			event?.stopPropagation()
			this.map_title_draft( id, this.spread_title( id ) )
			this.map_rename( id, true )
			new this.$.$mol_after_frame( ()=> this.map_rename_focus( id ) )
			return event ?? null
		}

		@ $mol_action
		map_rename_focus( id: string ) {
			const input = this.Map_title_input( id )
			input.focused( true )
			input.selection([ 0, this.map_title_draft( id ).length ])
		}

		@ $mol_action
		map_rename_pointerdown( _id: string, event?: PointerEvent | null ) {
			event?.stopPropagation()
			return event ?? null
		}

		@ $mol_action
		map_rename_click( _id: string, event?: MouseEvent | null ) {
			event?.preventDefault()
			event?.stopPropagation()
			return event ?? null
		}

		@ $mol_action
		map_rename_submit( id: string, event?: Event | null ) {
			this.map_title_save( id, this.map_title_draft( id ) )
			this.map_rename( id, false )
			return event ?? null
		}

		@ $mol_action
		map_rename_keydown( id: string, event?: KeyboardEvent | null ) {
			if( event?.key !== 'Escape' ) return event ?? null
			event.preventDefault()
			event.stopPropagation()
			this.map_title_draft( id, this.spread_title( id ) )
			this.map_rename( id, false )
			return event
		}

		map_ids_ordered( ids: readonly string[] ) {
			const sorted = this.sort_by() == 'title' 
				? ids.toSorted( $mol_compare_text( ((id: string) => this.map_props( id ).title ) ) )
				: this.sort_by() == 'changed'
					? ids.toSorted( (a,b) =>
						this.map_props( a ).changed_at - this.map_props( b ).changed_at 
					)
					: ids.toSorted( (a,b) =>
						this.map_props( a ).created_at - this.map_props( b ).created_at 
					)

			const ordered = this.sort_order() == 'asc' ? sorted : sorted.toReversed()
			return $shm_hitalama_map_catalog.grouped_ids(
				ordered,
				new Set( this.favorite_ids() ),
				new Set( this.owned_map_ids() ),
				new Set( this.available_map_ids() ),
			)
		}

		@ $mol_mem
		spread_ids_filtered() {
			return this.map_ids_ordered( super.spread_ids_filtered() )
		}

		project_node( id: string ) {
			return `project:${ id }`
		}

		map_node( id: string ) {
			return `map:${ id }`
		}

		project_id_from_node( node: string ) {
			return node.startsWith( 'project:' ) ? node.slice( 'project:'.length ) : ''
		}

		map_id_from_node( node: string ) {
			return node.startsWith( 'map:' ) ? node.slice( 'map:'.length ) : ''
		}

		@ $mol_mem
		owned_tree_model(): $shm_hitalama_map_catalog_tree_model {
			const data = this.map_projects()
			const owned = new Set( this.owned_map_ids() )
			const filtered = this.spread_ids_filtered().filter( id => owned.has( id ) )
			const all = this.map_ids_ordered( this.spread_ids() ).filter( id => owned.has( id ) )
			const filter = this.menu_filter().trim().toLowerCase()
			const assigned = new Set( data.projects.flatMap( project => project.map_ids ) )
			const roots: string[] = []
			const children = new Map< string, readonly string[] >()

			for( const project of data.projects ) {
				const title_matches = !filter || project.title.toLowerCase().includes( filter )
				const source = title_matches ? all : filtered
				const project_maps = new Set( project.map_ids )
				const child_ids = source.filter( id => project_maps.has( id ) )
				if( filter && !title_matches && !child_ids.length ) continue

				const node = this.project_node( project.id )
				roots.push( node )
				children.set( node, child_ids.map( id => this.map_node( id ) ) )
			}

			for( const id of filtered ) {
				if( assigned.has( id ) ) continue
				roots.push( this.map_node( id ) )
			}

			return { roots, children }
		}

		@ $mol_mem
		owned_tree_virtual_active( next?: boolean ) {
			return next ?? false
		}

		@ $mol_mem
		owned_tree_virtual_roots( next?: readonly string[] ) {
			return next ?? this.owned_tree_model().roots
		}

		@ $mol_mem_key
		owned_tree_virtual_children( id: string, next?: readonly string[] ) {
			return next ?? this.owned_tree_model().children.get( id ) ?? []
		}

		@ $mol_mem
		owned_tree_roots( next?: readonly string[] ) {
			if( next !== undefined ) {
				this.owned_tree_virtual_roots( [ ... next ] )
				return next
			}
			return this.owned_tree_virtual_active()
				? this.owned_tree_virtual_roots()
				: this.owned_tree_model().roots
		}

		@ $mol_mem_key
		owned_tree_children( id: string, next?: readonly string[] ) {
			if( next !== undefined ) {
				this.owned_tree_virtual_children( id, [ ... next ] )
				return next
			}
			return this.owned_tree_virtual_active()
				? this.owned_tree_virtual_children( id )
				: this.owned_tree_model().children.get( id ) ?? []
		}

		Owned_tree() {
			const tree = super.Owned_tree()
			const patched = tree as typeof tree & { _hitalama_map_catalog_patched?: true }
			if( patched._hitalama_map_catalog_patched ) return tree

			const on_drag_start = tree.on_drag_start.bind( tree )
			tree.on_drag_start = ( id: any, event: PointerEvent )=> {
				this.owned_tree_reset()
				return on_drag_start( id, event )
			}

			const on_drag_end = tree.on_drag_end.bind( tree )
			tree.on_drag_end = ( id: any, event?: PointerEvent )=> {
				const result = on_drag_end( id, event )
				this.owned_tree_commit_start()
				return result
			}

			patched._hitalama_map_catalog_patched = true
			return tree
		}

		@ $mol_action
		owned_tree_commit_start() {
			$mol_wire_async( this ).owned_tree_commit().then(
				()=> this.owned_tree_commit_finish(),
				error => this.owned_tree_commit_finish( error ),
			)
		}

		@ $mol_action
		owned_tree_commit_finish( error?: unknown ) {
			this.owned_tree_virtual_active( false )
			if( error ) $mol_fail_log( error )
		}

		@ $mol_action
		owned_tree_reset() {
			const model = this.owned_tree_model()
			this.owned_tree_virtual_roots( [ ... model.roots ] )
			for( const [ id, ids ] of model.children ) {
				this.owned_tree_virtual_children( id, [ ... ids ] )
			}
			this.owned_tree_virtual_active( true )
		}

		owned_tree_can_have_children( node: string ) {
			return Boolean( this.project_id_from_node( node ) )
		}

		owned_tree_can_be_child( node: string ) {
			return Boolean( this.map_id_from_node( node ) )
		}

		owned_tree_item_height( node: string ) {
			return 40
		}

		@ $mol_action
		owned_tree_commit() {
			const data = this.map_projects()
			const roots = this.owned_tree_roots()
			const visible_maps = new Set< string >()
			for( const node of roots ) {
				const map_id = this.map_id_from_node( node )
				if( map_id ) visible_maps.add( map_id )
				const project_id = this.project_id_from_node( node )
				if( !project_id ) continue
				for( const child of this.owned_tree_children( node ) ) {
					const child_id = this.map_id_from_node( child )
					if( child_id ) visible_maps.add( child_id )
				}
			}

			const projects = new Map( this.map_project_entities().map( project => [ project.link().str, project ] ) )
			const ordered_projects = roots
				.map( node => projects.get( this.project_id_from_node( node ) ) )
				.filter( ( project ): project is $shm_hitalama_map_project => Boolean( project ) )
			for( const project of this.map_project_entities() ) {
				if( !ordered_projects.includes( project ) ) ordered_projects.push( project )
			}
			const current_projects = this.map_project_entities()
			if( ordered_projects.length === current_projects.length
				&& ordered_projects.some( ( project, index )=> project !== current_projects[ index ] ) ) {
				this.profile()?.Map_projects_list( null ).remote_list( ordered_projects )
			}

			const assigned = new Set< string >()
			const maps = new Map( this.owned_entities().map( map => [ map.link().str, map ] ) )
			for( const project of data.projects ) {
				const node = this.project_node( project.id )
				const shown = roots.includes( node )
				if( !shown ) continue

				const visible = this.owned_tree_children( node )
					.map( child => this.map_id_from_node( child ) )
					.filter( id => id && !assigned.has( id ) )
				for( const id of visible ) assigned.add( id )
				const hidden = project.map_ids.filter( id => !visible_maps.has( id ) && !assigned.has( id ) )
				for( const id of hidden ) assigned.add( id )
				const next_ids = [ ... visible, ... hidden ]
				if( next_ids.length === project.map_ids.length
					&& next_ids.every( ( id, index )=> id === project.map_ids[ index ] ) ) continue

				const entity = this.map_project( project.id )
				if( !entity ) continue
				entity.Maps_list( null ).remote_list(
					next_ids.flatMap( id => maps.get( id ) ?? [] ),
				)
				entity.Changed_at( null )?.val( Date.now() )
			}
		}

		@ $mol_mem_key
		Owned_tree_item( node: string ): $mol_view {
			const project_id = this.project_id_from_node( node )
			if( project_id ) return this.Project_item( node )
			return this.Menu_item( this.map_id_from_node( node ) )
		}

		@ $mol_mem_key
		project_title( node: string, next?: string ) {
			const id = this.project_id_from_node( node )
			const project = this.map_project( id )
			const current = project?.title().trim() || 'Проект'
			if( next === undefined ) return current
			const title = next.trim() || current
			if( project && title !== current ) {
				project.title( title )
				project.Changed_at( null )?.val( Date.now() )
			}
			return title
		}

		@ $mol_mem_key
		project_rename( node: string, next?: boolean ) {
			return next ?? false
		}

		@ $mol_mem_key
		project_title_draft( node: string, next?: string ) {
			return next ?? this.project_title( node )
		}

		@ $mol_mem_key
		project_item_content( node: string ) {
			return this.project_rename( node )
				? [ this.Project_title_input( node ) ]
				: [ this.Project_menu( node ) ]
		}

		@ $mol_action
		project_rename_start( node: string, event?: Event | null ) {
			event?.preventDefault()
			event?.stopPropagation()
			this.project_title_draft( node, this.project_title( node ) )
			this.project_rename( node, true )
			new this.$.$mol_after_frame( ()=> this.project_rename_focus( node ) )
			return event ?? null
		}

		@ $mol_action
		project_rename_focus( node: string ) {
			const input = this.Project_title_input( node )
			input.focused( true )
			input.selection([ 0, this.project_title_draft( node ).length ])
		}

		@ $mol_action
		project_rename_pointerdown( _node: string, event?: PointerEvent | null ) {
			event?.stopPropagation()
			return event ?? null
		}

		@ $mol_action
		project_rename_submit( node: string, event?: Event | null ) {
			this.project_title( node, this.project_title_draft( node ) )
			this.project_rename( node, false )
			return event ?? null
		}

		@ $mol_action
		project_rename_keydown( node: string, event?: KeyboardEvent | null ) {
			if( event?.key !== 'Escape' ) return event ?? null
			event.preventDefault()
			event.stopPropagation()
			this.project_title_draft( node, this.project_title( node ) )
			this.project_rename( node, false )
			return event
		}

		@ $mol_mem
		project_delete_asked( next?: string ) {
			return next ?? ''
		}

		@ $mol_mem
		project_deleted( next?: $shm_hitalama_map_catalog_deleted_project | null ) {
			return next ?? null
		}

		project_menu_items( node: string ) {
			return this.project_delete_asked() === node
				? [ this.Project_delete_confirm( node ), this.Project_delete_cancel( node ) ]
				: [ this.Project_rename_action( node ), this.Project_delete( node ) ]
		}

		@ $mol_mem_key
		project_menu_offset( _node: string, next?: readonly number[] ) {
			return next ?? [ 0, 0 ]
		}

		@ $mol_action
		project_contextmenu( node: string, event?: MouseEvent | null ) {
			if( event === undefined ) return null
			event?.preventDefault()
			event?.stopPropagation()
			if( event ) {
				const rect = this.Project_title( node ).dom_node().getBoundingClientRect()
				this.project_menu_offset( node, [
					Math.max( 0, Math.min( 1, ( event.clientX - rect.left ) / Math.max( 1, rect.width ) ) ),
					Math.max( 0, Math.min( 1, ( event.clientY - rect.top ) / Math.max( 1, rect.height ) ) ),
				] )
			}
			this.project_delete_asked( '' )
			this.Project_menu( node ).showed( true )
			return event ?? null
		}

		@ $mol_action
		project_menu_rename( node: string, event?: Event | null ) {
			if( event === undefined ) return null
			this.Project_menu( node ).showed( false )
			return this.project_rename_start( node, event )
		}

		@ $mol_action
		project_delete( node: string, event?: Event | null ) {
			if( event === undefined ) return null
			event?.preventDefault()
			event?.stopPropagation()
			this.project_delete_asked( node )
			this.Project_menu( node ).showed( true )
			return event ?? null
		}

		@ $mol_action
		project_delete_cancel( node: string, event?: Event | null ) {
			if( event === undefined ) return null
			event?.preventDefault()
			event?.stopPropagation()
			if( this.project_delete_asked() === node ) this.project_delete_asked( '' )
			this.Project_menu( node ).showed( false )
			return event ?? null
		}

		@ $mol_action
		project_delete_confirm( node: string, event?: Event | null ) {
			if( event === undefined ) return null
			event?.preventDefault()
			event?.stopPropagation()
			const project = this.map_project( this.project_id_from_node( node ) )
			if( !project ) return event ?? null
			const list = this.profile()?.Map_projects_list( null )
			const index = list?.remote_list().findIndex( item => item.link().str === project.link().str ) ?? -1
			if( list && index >= 0 ) {
				this.project_deleted({ project, index, title: project.title().trim() || 'Проект' })
				list.cut( project.link() )
			}
			this.project_delete_asked( '' )
			this.owned_tree_virtual_active( false )
			return event ?? null
		}

		project_undo_title() {
			const deleted = this.project_deleted()
			return deleted ? `Отменить удаление «${ deleted.title }»` : 'Отменить удаление проекта'
		}

		@ $mol_action
		project_delete_undo( event?: Event | null ) {
			if( event === undefined ) return null
			const deleted = this.project_deleted()
			const list = this.profile()?.Map_projects_list( null )
			if( deleted && list ) {
				const current = list.remote_list()
				if( !current.some( project => project.link().str === deleted.project.link().str ) ) {
					const restored = [ ... current ]
					restored.splice( Math.min( deleted.index, restored.length ), 0, deleted.project )
					list.remote_list( restored )
				}
			}
			this.project_deleted( null )
			this.owned_tree_virtual_active( false )
			return event ?? null
		}

		map_menu_links() {
			const ids = this.spread_ids_filtered()
			const owned = new Set( this.owned_map_ids() )
			const visited = new Set( this.visited_map_ids() )
			const available = new Set( this.available_map_ids() )
			const projects_visible = this.map_projects().projects.length > 0
			const links: $mol_view[] = [
				... this.project_deleted() ? [ this.Project_undo() ] : [],
				... projects_visible && this.owned_tree_model().roots.length ? [ this.Owned_tree() ] : [],
			]
			let available_title = false, visited_title = false
			for( const id of ids ) {
				if( owned.has( id ) ) {
					if( !projects_visible ) links.push( this.Menu_item( id ) )
					continue
				}
				if( available.has( id ) && !available_title ) {
					links.push( this.Available_title() )
					available_title = true
				}
				if( visited.has( id ) && !visited_title ) {
					links.push( this.Visited_title() )
					visited_title = true
				}
				links.push( this.Menu_item( id ) )
			}
			return links
		}

		static grouped_ids( ordered: readonly string[], favorites: ReadonlySet< string >, owned: ReadonlySet< string >, available: ReadonlySet< string > = new Set ) {
			return [
				... ordered.filter( id => owned.has( id ) && favorites.has( id ) ),
				... ordered.filter( id => owned.has( id ) && !favorites.has( id ) ),
				... ordered.filter( id => !owned.has( id ) && available.has( id ) && favorites.has( id ) ),
				... ordered.filter( id => !owned.has( id ) && available.has( id ) && !favorites.has( id ) ),
				... ordered.filter( id => !owned.has( id ) && !available.has( id ) && favorites.has( id ) ),
				... ordered.filter( id => !owned.has( id ) && !available.has( id ) && !favorites.has( id ) ),
			]
		}

		@ $mol_mem_key
		public_icon_visible( id: string ) {
			return ['public_edit', 'public_read'].includes(this.map_props( id ).access_level)
				? super.public_icon_visible(id) : []
		}

		public_hint( id: string ) {
			return $shm_hitalama_map.access_level_title( this.map_props( id ).access_level )
		}

		map_favorite_store_key() {
			return 'map_favorite_ids'
		}

		map_visited_favorite_store_key() {
			return 'map_visited_favorite_ids'
		}

		@ $mol_mem
		map_favorite_ids( next?: readonly string[] ): string[] {
			const profile = this.profile()
			if( !profile ) return [] as string[]
			if( next !== undefined ) {
				profile.store( this.map_favorite_store_key(), Object.fromEntries(
					next.map( id => [ id, true ] )
				) )
				return [ ... next ]
			}

			return this.$.$mol_error_fence(
				()=> {
					const ids = profile.store( this.map_favorite_store_key() )
					if( Array.isArray( ids ) ) return ids.filter( id => typeof id === 'string' )
					return ids && typeof ids === 'object'
						? Object.keys( ids ).filter( id => ids[ id ] )
						: [] as string[]
				},
				()=> [],
				()=> [],
			)
		}

		@ $mol_mem
		map_visited_favorite_ids( next?: readonly string[] ): string[] {
			const profile = this.profile()
			if( !profile ) return []
			if( next !== undefined ) {
				profile.store( this.map_visited_favorite_store_key(), Object.fromEntries(
					next.map( id => [ id, true ] ),
				) )
				return [ ... next ]
			}

			return this.$.$mol_error_fence(
				()=> {
					const ids = profile.store( this.map_visited_favorite_store_key() )
					if( Array.isArray( ids ) ) return ids.filter( id => typeof id === 'string' )
					return ids && typeof ids === 'object'
						? Object.keys( ids ).filter( id => ids[ id ] )
						: []
				},
				()=> [],
				()=> [],
			)
		}

		favorite_ids() {
			return [ ... new Set([ ... this.map_favorite_ids(), ... this.map_visited_favorite_ids() ]) ]
		}

		@ $mol_action
		favorites_migration_auto() {
			const visited = new Set( this.visited_map_ids() )
			const owned_ids = this.map_favorite_ids()
			const legacy = owned_ids.filter( id => visited.has( id ) )
			if( !legacy.length ) return null

			this.map_visited_favorite_ids([
				... new Set([ ... this.map_visited_favorite_ids(), ... legacy ]),
			])
			this.map_favorite_ids( owned_ids.filter( id => !visited.has( id ) ) )
			return null
		}

		@ $mol_mem_key
		map_favorite( id: string, next?: boolean ) {
			const owned = this.owned_map_ids().includes( id )
			const owned_ids = this.map_favorite_ids()
			const visited_ids = this.map_visited_favorite_ids()
			const exists = owned_ids.includes( id ) || visited_ids.includes( id )
			if( next === undefined ) return exists

			const owned_next = owned_ids.filter( item => item !== id )
			const visited_next = visited_ids.filter( item => item !== id )
			if( next ) {
				if( owned ) owned_next.push( id )
				else visited_next.push( id )
			}

			this.map_favorite_ids( owned_next )
			this.map_visited_favorite_ids( visited_next )
			if( next && !owned ) this.map_visit( id )
			return next
		}

		favorite_hint( id: string ) {
			return this.map_favorite( id ) ? 'Убрать из избранного' : 'Добавить в избранное'
		}

		@ $mol_action
		favorite_toggle( id: string, event?: Event | null ) {
			event?.preventDefault()
			event?.stopPropagation()
			this.map_favorite( id, !this.map_favorite( id ) )
			return event ?? null
		}

		@ $mol_mem_key
		editor_mode_link( id: string ) {
			return { ... this.menu_link_arg( id ), edit_mode: '' }
		}

		editor_mode_current( id: string ) {
			return this.spread() === id && this.$.$mol_state_arg.value( 'edit_mode' ) === ''
		}

		add_map( access_level: keyof ReturnType<typeof $shm_hitalama_map.access_level_to_ranks> ) {
			const titles = this.owned_map_ids().map( id => this.map_props( id ).title )
			const title = $shm_hitalama_inc_name( titles, this.title_default() )

			const map = $shm_hitalama_map.make_new( title, access_level )!
			this.list().add( map.link() )
			map.summary_publish()
			this.$.$mol_state_arg.dict({
				... this.$.$mol_state_arg.dict(),
				shift_x: null,
				shift_y: null,
				zoom: null,
			})
			this.spread( map.link().toString() )
			return map
		}

		@ $mol_action
		add_project( event?: Event | null ) {
			event?.preventDefault()
			event?.stopPropagation()
			const data = this.map_projects()
			const title = $shm_hitalama_inc_name(
				data.projects.map( project => project.title ),
				'Проект',
			)
			const project = this.profile()?.add_map_project( title ) ?? null
			return project
		}

		// commented for make it unchangeable
		// @ $mol_mem
		// sort_order( next?: string ): string {
		// 	return this.profile()?.Maps_sort_order(next)?.val(next) ?? 'asc'
		// }

		@ $mol_mem
		sort_by( next?: string ): string {
			return this.profile()?.Maps_sort_by(next)?.val(next) ?? 'created'
		}

		@ $mol_action
		add() {
			return this.add_map( 'private' )
		}

		@ $shm_hitalama_process_wire_action
		import( files: File[] ) {
			const json = $mol_wire_sync(this.$).$mol_blob_json( files[0] )
			const map = this.add()
			map.deserialize( json )
		}

	}

}
